export default __webpack_public_path__ + "static/media/Interior (13).9869127c.jpg";